package com.dignicate.web.data.markdown.parser.handlers

import com.dignicate.web.data.markdown.model.MarkdownBlock
import com.dignicate.web.data.markdown.parser.core.MarkdownHandler
import com.dignicate.web.data.markdown.parser.core.ParsingContext

class CodeFenceHandler : MarkdownHandler {
    override fun canHandle(ctx: ParsingContext): Boolean {
        return ctx.currentLine()?.startsWith("```") == true
    }

    override fun handle(ctx: ParsingContext) {
        val language = ctx.currentLine()!!.drop(3).trim().ifEmpty { null }
        val codeLines = mutableListOf<String>()
        ctx.index++
        while (!ctx.isEof() && ctx.currentLine()!! != "```") {
            codeLines.add(ctx.currentLine()!!)
            ctx.index++
        }
        ctx.blocks.add(MarkdownBlock.CodeBlock(language, codeLines.joinToString("\n")))
        ctx.index++
    }
}
